import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { Link, Redirect } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";
import axios from "axios";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button,
  Timespanpicker
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard
} from "variables/charts.jsx";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";
import moment from "moment";
import {Timepicker} from 'react-timepicker';
import 'react-timepicker/timepicker.css';
import { faThemeisle } from "@fortawesome/free-brands-svg-icons";
import { Table, Tag, Drawer, Button as AntButton } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
  InfoCircleOutlined,
  LoadingOutlined
} from '@ant-design/icons';


// import TextField from '@mui/material/TextField';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { TimePicker } from '@mui/x-date-pickers/TimePicker';

class CheckinList extends React.Component {
  constructor(props) {
    super(props);
    moment.locale("es");
    /* ////console.log("########## PROPS ###########");
    ////console.log(props); */
    let myCompany = null;
    if (this.props.myCompany) {
      myCompany = this.props.myCompany;
    } else {
      myCompany = (this.props.mainState && this.props.mainState.myCompany) ? this.props.mainState.myCompany : null;
    }

    this.state = {
      myCompany: myCompany,
      // myCheckers: myCheckers,
      // checkins: [],
      // // myEmployees: myEmployees,
      // servicesSize: "auto",
      // pagination: { pageSize: 20, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '40'] },
      // openDetails: null,
      // lastCheckins: []
    };

    // this.loadCheckins = this.loadCheckins.bind(this);
    // this.buildCheckins = this.buildCheckins.bind(this);
    // this.getDrawer = this.getDrawer.bind(this);
    // this.onCloseDrawer = this.onCloseDrawer.bind(this);
  }
  componentDidMount() {
    // this.loadCheckins();
    // this.loadMyEmployees();
  }
  componentWillUnmount() {
    // this.props.saveMyCompany(this.state.myCompany);
    // this.props.saveMyCompanyWorkplaces(this.state.myCheckers);
    // this.props.saveMyEmployees(this.state.myEmployees);
    // this.props.saveMyCheckers(this.state.myCheckers);
  }
  render() {
    // console.log("this.state", this.state);
    return (
      <div>
        <PanelHeader
          size="sm"
          // content={this.createMyCompanyCard()}
        />
        <div className="content">
          <Row>
            <Col xs={12} sm={6} md={4}>
              <Card className="card-stats card-raised">
                <CardBody>
                  <Row>
                    <Col xs={12} md={12}>
                      <Link to={"/fichajes/hoy"}>
                        <Statistics
                          showIcon
                          iconState="info"
                          icon="users_single-02"
                          title="Hoy"
                          subtitle="Fichajes de hoy"
                        />
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col xs={12} sm={6} md={4}>
              <Card className="card-stats card-raised">
                <CardBody>
                  <Row>
                    <Col xs={12} md={12}>
                      <Link to={"/fichajes/todos"}>
                        <Statistics
                          showIcon
                          iconState="info"
                          icon="users_single-02"
                          title="Todos"
                          subtitle="Lista de fichajes"
                        />
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default CheckinList;



// WEBPACK FOOTER //
// ./src/views/CheckIn/CheckinList.jsx